module.exports = __webpack_public_path__ + "static/img/label-icon3-en.dae58da7.png";